import { useQuery } from "@tanstack/react-query"
import { getDurations, getFormats, getNiches, getTopics } from "@/entities/category"

export function usePostFormTaxonomy() {
	const { data: formats, isLoading: formatsLoading } = useQuery({
		queryKey: ["formats"],
		queryFn: getFormats,
	})

	const { data: niches, isLoading: nichesLoading } = useQuery({
		queryKey: ["niches"],
		queryFn: getNiches,
	})

	const { data: topics, isLoading: topicsLoading } = useQuery({
		queryKey: ["topics"],
		queryFn: getTopics,
	})

	const { data: durations, isLoading: durationsLoading } = useQuery({
		queryKey: ["durations"],
		queryFn: getDurations,
	})

	return {
		formats,
		niches,
		topics,
		durations,
		isLoading: formatsLoading || nichesLoading || topicsLoading || durationsLoading,
	}
}
